<template>
  <div class="container reserved-document">
    <div class="breadcrumb-password-view py-3 row"></div>
    <Breadcrumb :path-list="{ 'Emissão de Certificado': '#', BirdId: '#' }" />
    <div class="alert alert-dismissible alert-success mb-1" role="alert">
      <div class="alert__icon">
        <Icon name="shield" />
      </div>
      <div class="alert__content">
        <div class="text">
          Parabéns! Sua solicitação foi aprovada com sucesso! Verifique seu
          e-mail.
        </div>
        <button
          class="btn-close"
          type="button"
          data-bs-dismiss="alert"
          aria-label="Fechar"
        >
          <Icon name="xmark" class="mt-2" />
        </button>
      </div>
    </div>

    <div class="text-start d-flex mt-4 justify-content-between">
      <div class="card-left col-md-7 col-12 print-section">
        <div class="text-center fw-600">DOCUMENTO RESERVADO</div>
        <div class="divisor"></div>
        <div>Dados para emitir Certificado Digital após aprovação</div>
        <div>
          <strong>Código da solicitação: </strong>{{ form.codigoSolicitacao }}
        </div>
        <div class="divisor"></div>
        <div>
          Após aprovação da sua Solicitação, utilize os dados informados abaixo
          para fazer a instalação do Certificado Digital.
        </div>
        <div class="info-box">
          <span class="fw-600">Usuário: </span> {{ form.user }}
        </div>
        <div class="info-box">
          <span class="fw-600">Senha: </span> criada pelo usuário
        </div>
        <div class="d-flex justify-content-end">
          <RouterLink
            :to="`/${form.arData.subdomain}/guia-de-instalacao-de-certificado-digital`"
            class="btn btn-primary btn-sm"
          >
            <Icon name="shield" />
            <span class="ms-2">Instalar Certificado</span>
          </RouterLink>
        </div>

        <div class="divisor"></div>
        <div class="fw-600">Atenção</div>
        <div>
          <span class="fw-600">Para sua segurança</span>, guarde este documento
          em local seguro até que emita seu Certificado Digital Soluti.
        </div>
        <div>
          Após a emissão, esses dados não serão mais necessários e este
          documento poderá ser descartado.
        </div>
        <div class="d-flex justify-content-end btn-imprimir">
          <button class="btn btn-outline-primary btn-sm" @click="imprimir">
            <Icon name="print" />
            <span class="ms-2">Imprimir</span>
          </button>
        </div>
      </div>
      <div class="col-md-4 d-none d-md-block">
        <img
          class="ms-4 card-right-img"
          src="@/assets/images/paperGirl.png"
          alt="Desenho de uma menina com um folha de papel atrás."
        />
      </div>
    </div>
    <Contact />
  </div>
  <DocumentToPrint class="document-to-print" />
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import Breadcrumb from '@/components/Molecules/Breadcrumbs.vue'
  import Contact from '@/components/Molecules/Contact.vue'
  import { mapActions, mapState } from 'pinia'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'
  import { useAR, ArDataType } from '@/store/Pinia/useAR.store'
  import browserDeviceCheck from '@/utils/browserDeviceCheck'
  import DocumentToPrint from './DocumentToPrint.vue'
  import { RouterLink } from 'vue-router'

  export default defineComponent({
    name: 'ReservedDocumentView',
    components: {
      Contact,
      Icon,
      Breadcrumb,
      DocumentToPrint,
      RouterLink,
    },
    data: () => ({
      form: {
        arData: {} as ArDataType,
        codigoSolicitacao: '',
        user: '',
      },
      isMobile: browserDeviceCheck(),
    }),
    computed: {
      ...mapState(useSolicitation, ['getSolicitation']),
      ...mapState(useAR, ['arData']),
    },
    mounted() {
      this.form.arData = this.arData
      this.form.codigoSolicitacao = this.getSolicitation.cdSolicitacao
      this.form.user = this.getSolicitation.userName

      this.cleanVoucher()
    },
    methods: {
      ...mapActions(useSolicitation, ['cleanVoucher']),
      imprimir() {
        window.print()
      },
    },
  })
</script>

<style lang="stylus">
  .document-to-print
    display: none;

  .reserved-document
    .alert .btn-close
      top: 0.2em
    .card-left
      display: flex
      flex-direction: column

      border-radius: 10px
      border: 1px solid #E6E7EC
      gap: 1rem
      padding: 24px 16px 24px 16px
      background-color: #FFFFFF

    .divisor
      border-bottom: 1px solid #E6E7EC

    .info-box
      border-radius: 8px
      padding: 10px
      background-color: #F0F0F3

  @media print
    .footer
      display: none !important
    .header-component, .reserved-document
      display: none
    .document-to-print
      display: flex
</style>
